<template>
   <div>

        <BoxInfoPatient :PatientCode="this.$route.params.id" :AdmissionRecordId="this.$route.params.recordid" v-bind:OpenInModal="true"></BoxInfoPatient>

          <div class="layout">
            <!--<button class="sidebar-toggle" @click="showSidebar = !showSidebar">{{ showSidebar ? '◀' : '▶' }}</button>-->
            <aside class="sidebar" :class="{ collapsed: !showSidebar }">
                <ul>
                    <li @click="section='SeeAll'"  :class="{ active: section === 'SeeAll' }">{{this.$t('FirstDataBank.AllDrugsSearch')}}</li>
                    <li @click="section='details'"  :class="{ active: section === 'details' }">{{this.$t('FirstDataBank.Detail')}}</li>
                    <li v-if="ModelFilter !== 1" @click="section='images'"  :class="{ active: section === 'images' }">{{this.$t('FirstDataBank.Images')}}</li>
                    <li @click="section='indications'"  :class="{ active: section === 'indications' }">{{this.$t('FirstDataBank.Indications')}}</li>
                    <li @click="section='effects'" :class="{ active: section === 'effects' }">{{this.$t('FirstDataBank.SideEffects')}}</li>

                    <li @click="section='DrugInteractions'" :class="{ active: section === 'DrugInteractions' }">{{this.$t('FirstDataBank.DrugInteractions')}}</li>
                    <li @click="section='PatientEducation'" :class="{ active: section === 'PatientEducation' }">{{this.$t('FirstDataBank.PatientEducation')}}</li>
                    <li @click="section='Dosing'" :class="{ active: section === 'Dosing' }">{{this.$t('FirstDataBank.Dosing')}}</li>
                    <li @click="section='MinMaxDosing'" :class="{ active: section === 'MinMaxDosing' }">{{this.$t('FirstDataBank.MinMaxDosing')}}</li>
                    <li v-if="ModelFilter === 3" @click="section='CurrentPrices'" :class="{ active: section === 'CurrentPrices' }">{{this.$t('FirstDataBank.CurrentPrices')}}</li>
                    <li @click="section='LabelWarnings'" :class="{ active: section === 'LabelWarnings' }">{{this.$t('FirstDataBank.LabelWarnings')}}</li>
                    <li @click="section='Interoperability'" :class="{ active: section === 'Interoperability' }">{{this.$t('FirstDataBank.Interoperability')}}</li>
                    <li @click="section='ClinicalQuantity'" :class="{ active: section === 'ClinicalQuantity' }">{{this.$t('FirstDataBank.ClinicalQuantity')}}</li>
                </ul>
            </aside>

            <div class="separate"></div>
             <main class="content">
                <div v-if="section === 'SeeAll'">
                      <b-row>
                        <b-col lg="3" md="3" sm="12">
                            <MdSelect
                                v-bind:Label="this.$t('Shared.Type')"
                                v-bind:Options="FilterList"
                                v-bind:FieldDescription="'name'"
                                v-bind:FieldCode="'code'"
                                v-bind:AllowEmpty="false"
                                v-bind:Model="ModelFilter"
                                v-bind:Multiple="false"
                                :Input="ChangeDropDownFilter"
                            />
                        </b-col>
                        <b-col lg="9" md="9" sm="12">
                            <MdEditSearch
                                :Id="'MedicationSearchDataBank'"
                                :DataList="DataBankList"
                                :SearchHandler="SearchHandler"
                                :showDropdown.sync="showDropdown"
                                :ItemHandler="ItemHandler"
                                :IsVisibleMoreResult="ModelFilter === 2 ? false : true"
                                @see-more-results="SeeMoreRecords"
                                :SearchCriteria.sync="searchCriteriaLocal">
                            </MdEditSearch>
                        </b-col>
                    </b-row>

                    <MdTablePaginationClient v-if="IsSeeMoreRecords"
                        v-bind:refTable="'SeeAll'"
                        :key="'SeeAll'"
                        v-bind:fields="fieldsDataBankListAll"
                        v-bind:items="DataBankListAll"
                        v-bind:totalRows="totalRowsDataBankListAll"
                        v-bind:isReadOnly="false"
                        :viewIconEvent="handleViewAllEvent"
                        v-bind:showMessageIsEmpty="ShowMessageIsEmptyDataBankListAll"
                        v-bind:currentPage="currentPageDataBankListAll"
                        v-bind:perPage="perPageDataBankListAll"
                        v-bind:pageOptions="pageOptionsDataBankListAll"
                        :pageChanged="pageChangedDataBankListAll"
                        :perPageFunction="PerPageFunctionDataBankListAll">
                    </MdTablePaginationClient>
                </div>

                <div v-if="section === 'SeeAll' && ModelFilter === 3">
                    <MdTablePaginationClient
                        v-bind:refTable="'SeeAll'"
                        :key="'SeeAll'"
                        v-bind:fields="fieldsPackageListAll"
                        v-bind:items="ItemsPackage"
                        v-bind:totalRows="totalRowsPackageListAll"
                        v-bind:isReadOnly="false"
                        :viewIconEvent="handleViewPackageEvent"
                        v-bind:showMessageIsEmpty="ShowMessageIsEmptyPackageListAll"
                        v-bind:currentPage="currentPagePackageListAll"
                        v-bind:perPage="perPagePackageListAll"
                        v-bind:pageOptions="pageOptionsPackageListAll"
                        :pageChanged="pageChangedPackageListAll"
                        :perPageFunction="PerPageFunctionPackageListAll">
                    </MdTablePaginationClient>
                </div>

                <div v-if="section === 'details'">

                    <div class="grid-margin stretch-card">
					<div class="card activeCard">
						<div class="card-body">
							<div class="d-flex align-items-start justify-content-between pointer forceLTR">
							<h6 class="card-title flex-grow lower-line text-truncate">{{this.$t('FirstDataBank.Detail')}}</h6>

							</div>
							<div class="flex-container" v-if="LoadDetail">
								<div class="row">
									<div class="col-md-4">
										<div class="float-left col text-muted p-item">
											<small>{{this.$t('FirstDataBank.MedicationDescription')}}</small><br>
											<b>{{Detail.dispensableDrugDesc}}</b>
										</div>
									</div>

                                    <div class="col-md-4">
										<div class="float-left col text-muted p-item">
											<small>{{this.$t('FirstDataBank.DefaultEnhancedTherapeuticClassETC')}}</small><br>
											<b>{{Detail.defaultETCDesc}}</b>
										</div>
									</div>

                                    <div class="col-md-4">
										<div class="float-left col text-muted p-item">
											<small>{{this.$t('FirstDataBank.ActiveIngredients')}}</small><br>
											<b>{{Detail.activeIngredients}}</b>
										</div>
									</div>

                                    <div class="col-md-4">
										<div class="float-left col text-muted p-item">
											<small>{{this.$t('FirstDataBank.ControlledSubstanceCode')}}</small><br>
											<b>{{Detail.federalDEAClassCodeDesc}}</b>
										</div>
									</div>

                                    <div class="col-md-4">
										<div class="float-left col text-muted p-item">
											<small>{{this.$t('FirstDataBank.FederalLegendCode')}}</small><br>
											<b>{{Detail.federalLegendCodeDesc}}</b>
										</div>
									</div>

                                    <div class="col-md-4">
										<div class="float-left col text-muted p-item">
											<small>{{this.$t('FirstDataBank.IsMedicalDevice')}}</small><br>
											<b>{{Detail.isMedicalDevice}}</b>
										</div>
									</div>

                                    <div class="col-md-4">
										<div class="float-left col text-muted p-item">
											<small>{{this.$t('FirstDataBank.IsSingleIngredient')}}</small><br>
											<b>{{Detail.isSingleIngredient}}</b>
										</div>
									</div>

                                    <div class="col-md-4">
										<div class="float-left col text-muted p-item">
											<small>{{this.$t('FirstDataBank.DrugNameSourceCode')}}</small><br>
											<b>{{Detail.nameTypeCodeDesc}}</b>
										</div>
									</div>

                                    <div class="col-md-4">
										<div class="float-left col text-muted p-item">
											<small>{{this.$t('FirstDataBank.GenericDrugNameCode')}}</small><br>
											<b>{{Detail.genericDrugNameCodeDesc}}</b>
										</div>
									</div>


								</div>
							</div>
                            <div v-if="!LoadDetail">
                                <div class="alert alert-fill-success d-flex align-items-center m-3" role="alert">
                                    <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                                    <div class="flex-grow-1">
                                        <span>{{this.$t('FirstDataBank.MessageLoadDetail')}}</span>
                                    </div>
                                </div>
                            </div>
						</div>
						</div>
					</div>

                </div>
                 <div v-if="section === 'images' && ModelFilter !== 1">
                    <div class="image-gallery">
                        <div v-for="item in imageUrlList" :key="item.imageID" class="image-card">
                            <img v-if="item.imageUrl" :src="`${item.imageUrl}`"/>
                            <div class="image-label"> {{ item.imageDesc }} </div>
                        </div>
                        <div v-if="imageUrlList.length === 0" class="empty-images">
                            <i class="fa fa-medkit empty-icon"></i>
                            <h3>{{this.$t('FirstDataBank.NoImagesAvailable')}}</h3>
                            <p>{{this.$t('FirstDataBank.MessageNoImage')}}</p>
                        </div>
                    </div>
                 </div>

                <div v-if="section === 'indications'">
                    <MdTablePaginationClient
                        v-bind:refTable="'Indication'"
                        :key="'Indication'"
                        v-bind:fields="fieldsIndication"
                        v-bind:items="ItemsIndication"
                        v-bind:totalRows="totalRowsIndication"
                        v-bind:isReadOnly="false"
                        v-bind:showMessageIsEmpty="ShowMessageIsEmptyIndication"
                        v-bind:currentPage="currentPageIndication"
                        v-bind:perPage="perPageIndication"
                        v-bind:pageOptions="pageOptionsIndication"
                        :pageChanged="pageChangedIndication"
                        :perPageFunction="PerPageFunctionIndication">
                    </MdTablePaginationClient>
                </div>

                <div v-if="section === 'effects'">
                    <b-row>
                        <b-col lg="3" md="3" sm="12">
                            <MdSelect
                                v-bind:Label="'Severities'"
                                v-bind:Options="SeveritiesList"
                                v-bind:FieldDescription="'name'"
                                v-bind:FieldCode="'code'"
                                v-bind:AllowEmpty="false"
                                v-bind:Model="ModelSeverities"
                                v-bind:Multiple="false"
                                :Input="ChangeDropDownSeverities"
                            />
                        </b-col>
                    </b-row>
                    <MdTablePaginationClient
                        v-bind:refTable="'effects'"
                        :key="'effects'"
                        :IsDataBankSideEffect="true"
                        v-bind:fields="fieldsSideEffects"
                        v-bind:items="ItemsSideEffects"
                        v-bind:totalRows="totalRowsSideEffects"
                        v-bind:isReadOnly="false"
                        v-bind:showMessageIsEmpty="ShowMessageIsEmptySideEffects"
                        v-bind:currentPage="currentPageSideEffects"
                        v-bind:perPage="perPageSideEffects"
                        v-bind:pageOptions="pageOptionsSideEffects"
                        :pageChanged="pageChangedSideEffects"
                        :perPageFunction="PerPageFunctionSideEffects">
                    </MdTablePaginationClient>
                </div>

                <div v-if="section === 'DrugInteractions'">
                    <MdTablePaginationClient
                        v-bind:refTable="'DrugInteractions'"
                        :key="'DrugInteractions'"
                        v-bind:fields="fieldsInteractions"
                        v-bind:items="ItemsInteractions"
                        v-bind:totalRows="totalRowsInteractions"
                        :IsDataBankInteraction="true"
                        v-bind:isReadOnly="false"
                        v-bind:showMessageIsEmpty="ShowMessageIsEmptyInteractions"
                        v-bind:currentPage="currentPageInteractions"
                        v-bind:perPage="perPageInteractions"
                        :viewIconEvent="handleViewEvent"
                        v-bind:pageOptions="pageOptionsInteractions"
                        :pageChanged="pageChangedInteractions"
                        :perPageFunction="PerPageFunctionInteractions">
                    </MdTablePaginationClient>
                </div>

                <div v-if="section === 'PatientEducation'">
                    <b-row class="position-relative">
                        <!--<b-button variant="link" class="print-btn" v-b-tooltip.hover :title="$t('Shared.Print')">
                         <i class="fas fa-print"></i>
                        </b-button>-->
                        <span class="rounded-circle tableActionBTN tableBTNtext print-btn ikon med-print" v-on:click="print" v-b-tooltip.hover :title="$t('Shared.Print')"></span>
                        <b-col md="12" class="mt-5">
                            <div id="printArea">
                                <div v-for="(item,key) in PatientEducationMonographsSectionList" :key="key"  class="mb-1">
                                    <b>{{item.title}}</b><br>
                                    <p class="justified-text">{{item.text}}</p>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>

                <div v-if="section === 'Dosing'">
                    <!--<TreeNode :node="treeData"></TreeNode>-->
                    <MdTablePaginationClient
                        v-bind:refTable="'Dosing'"
                        :key="'Dosing'"
                        v-bind:fields="fieldsDosing"
                        v-bind:items="ItemsDosing"
                        v-bind:totalRows="totalRowsDosing"
                        v-bind:isReadOnly="false"
                        :viewIconEvent="DosingView"
                        v-bind:showMessageIsEmpty="ShowMessageIsEmptyDosing"
                        v-bind:currentPage="currentPageDosing"
                        v-bind:perPage="perPageDosing"
                        v-bind:pageOptions="pageOptionsDosing"
                        :pageChanged="pageChangedDosing"
                        :perPageFunction="PerPageFunctionDosing">
                    </MdTablePaginationClient>
                </div>

                <div v-if="section === 'MinMaxDosing'">

                    <div class="grid-margin stretch-card" v-if="VisibleMainDose">
                        <div class="card activeCard">
                            <div class="card-body">
                                <div class="d-flex align-items-start justify-content-between pointer forceLTR">
                                <h6 class="card-title flex-grow lower-line text-truncate"> {{this.$t('FirstDataBank.MainDoseDetail')}} </h6>

                                </div>
                                <div class="flex-container">
                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="float-left col text-muted p-item">
                                                <small>{{this.$t('FirstDataBank.ageRange')}}</small><br>
                                                <b>{{MainDose.ageRange}}</b>
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <div class="float-left col text-muted p-item">
                                                <small>{{this.$t('FirstDataBank.doseMin')}}</small><br>
                                                <b>{{MainDose.doseMin}}</b>
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <div class="float-left col text-muted p-item">
                                                <small>{{this.$t('FirstDataBank.doseMax')}}</small><br>
                                                <b>{{MainDose.doseMax}}</b>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
						</div>
					</div>



                    <MdTablePaginationClient
                        v-bind:refTable="'MinMaxDosing'"
                        :key="'MinMaxDosing'"
                        v-bind:fields="fieldsDoseRecordsMinMax"
                        v-bind:items="ItemsDoseRecordsMinMax"
                        v-bind:totalRows="totalRowsDoseRecordsMinMax"
                        v-bind:isReadOnly="false"
                        v-bind:showMessageIsEmpty="ShowMessageIsEmptyDoseRecordsMinMax"
                        v-bind:currentPage="currentPageDoseRecordsMinMax"
                        v-bind:perPage="perPageDoseRecordsMinMax"
                        v-bind:pageOptions="pageOptionsDoseRecordsMinMax"
                        :pageChanged="pageChangedDoseRecordsMinMax"
                        :perPageFunction="PerPageFunctionDoseRecordsMinMax">
                    </MdTablePaginationClient>
                </div>

                 <div v-if="section === 'CurrentPrices' && ModelFilter === 3">
                    <MdTablePaginationClient
                        v-bind:refTable="'CurrentPrices'"
                        :key="'CurrentPrices'"
                        v-bind:fields="fieldsCurrentPrices"
                        v-bind:items="ItemsCurrentPrices"
                        v-bind:totalRows="totalRowsCurrentPrices"
                        v-bind:isReadOnly="false"
                        v-bind:showMessageIsEmpty="ShowMessageIsEmptyCurrentPrices"
                        v-bind:currentPage="currentPageCurrentPrices"
                        v-bind:perPage="perPageCurrentPrices"
                        v-bind:pageOptions="pageOptionsCurrentPrices"
                        :pageChanged="pageChangedCurrentPrices"
                        :perPageFunction="PerPageFunctionCurrentPrices">
                    </MdTablePaginationClient>
                </div>

                <div v-if="section === 'LabelWarnings'">
                   <MdTablePaginationClient
                        v-bind:refTable="'LabelWarnings'"
                        :key="'LabelWarnings'"
                        v-bind:fields="fieldsLabelWarning"
                        v-bind:items="ItemsLabelWarning"
                        v-bind:totalRows="totalRowsLabelWarning"
                        v-bind:isReadOnly="false"
                        v-bind:showMessageIsEmpty="ShowMessageIsEmptyLabelWarning"
                        v-bind:currentPage="currentPageLabelWarning"
                        v-bind:perPage="perPageLabelWarning"
                        v-bind:pageOptions="pageOptionsLabelWarning"
                        :pageChanged="pageChangedLabelWarning"
                        :perPageFunction="PerPageFunctionLabelWarning">
                    </MdTablePaginationClient>
                </div>

                <div v-if="section === 'Interoperability'">
                    <MdTablePaginationClient
                        v-bind:refTable="'Interoperability'"
                        :key="'Interoperability'"
                        v-bind:fields="fieldsInteroperability"
                        v-bind:items="ItemsInteroperability"
                        v-bind:totalRows="totalRowsInteroperability"
                        v-bind:isReadOnly="false"
                        v-bind:showMessageIsEmpty="ShowMessageIsEmptyInteroperability"
                        v-bind:currentPage="currentPageInteroperability"
                        v-bind:perPage="perPageInteroperability"
                        v-bind:pageOptions="pageOptionsInteroperability"
                        :pageChanged="pageChangedInteroperability"
                        :perPageFunction="PerPageFunctionInteroperability">
                    </MdTablePaginationClient>
                </div>

                <div v-if="section === 'ClinicalQuantity'">
                    <MdTablePaginationClient
                        v-bind:refTable="'ClinicalQuantity'"
                        :key="'ClinicalQuantity'"
                        v-bind:fields="fieldsClinicalQuantities"
                        v-bind:items="ItemsClinicalQuantities"
                        v-bind:totalRows="totalRowsClinicalQuantities"
                        v-bind:isReadOnly="false"
                        v-bind:showMessageIsEmpty="ShowMessageIsEmptyClinicalQuantities"
                        v-bind:currentPage="currentPageClinicalQuantities"
                        v-bind:perPage="perPageClinicalQuantities"
                        v-bind:pageOptions="pageOptionsClinicalQuantities"
                        :pageChanged="pageChangedClinicalQuantities"
                        :perPageFunction="PerPageFunctionClinicalQuantities">
                    </MdTablePaginationClient>
                </div>




            </main>
        </div>

        <BaseModal
          v-if="VisibleProfessionalMonograph"
          :key="'ModalDrugInteractionProfessionalMonograph'"
          ModalId="ModalDrugInteractionProfessionalMonograph"
          :TitleWindow="this.$t('FirstDataBank.DrugInteractionProfessionalMonograph')"
          :width="'65%'"
          :height="'60vh'"

          :HideModalFun="ProfessionalMonographOnCancel"
          @Close="ProfessionalMonographOnCancel"
          :buttons="[
              { text: $t('Shared.Close'), variant: 'secondary', action: 'Close' }
          ]">

          <b-row>
            <b-col md="6" class="border-right-column">
                 <div v-for="(item,key) in ProfessionalMonographSectionList" :key="key"  class="mb-1">
                     <b>{{item.title}}</b><br>
                     <p class="justified-text">{{item.text}}</p>
                 </div>
            </b-col>
             <b-col md="6">
                 <b>{{this.$t('FirstDataBank.References')}} </b><br>
                <div v-for="(item,key) in ProfessionalMonographReferenceList" :key="key"  class="mb-1">
                     <p class="justified-text">{{item.referenceText}}</p>
                 </div>
             </b-col>
          </b-row>


      </BaseModal>


      <BaseModal
          v-if="VisibleDoseRecord"
          :key="'ModalDrugDosing'"
          ModalId="ModalDrugDosing"
          :TitleWindow="this.$t('FirstDataBank.DoseRecord')"
          :width="'45%'"
          :height="'60vh'"
          :HideModalFun="DoseRecordOnCancel"
          @Close="DoseRecordOnCancel"
          :buttons="[
              { text: $t('Shared.Close'), variant: 'secondary', action: 'Close' }
          ]">

          <b-row>
            <b-col md="12">
                    <b>{{this.$t('FirstDataBank.AgeSourceDesc')}} </b><br>
                    <p class="justified-text">{{DoseItem.ageSourceDesc}}</p>

                    <b>{{this.$t('FirstDataBank.ClinicalRoute')}}</b><br>
                    <p class="justified-text">{{DoseItem.clinicalRoute}}</p>

                    <b>{{this.$t('FirstDataBank.CreatinineClearanceRange')}}</b><br>
                    <p class="justified-text">{{DoseItem.creatinineClearanceRange}}</p>

                    <b>{{this.$t('FirstDataBank.GenericEquivalentDrugDesc')}} </b><br>
                    <p class="justified-text">{{DoseItem.genericEquivalentDrugDesc}}</p>

                    <b>{{this.$t('FirstDataBank.PatientGestationalAgeRange')}} </b><br>
                    <p class="justified-text">{{DoseItem.patientGestationalAgeRange}}</p>

                    <b>{{this.$t('FirstDataBank.PatientWeightRange')}}</b><br>
                    <p class="justified-text">{{DoseItem.patientWeightRange}}</p>

                    <b>{{this.$t('FirstDataBank.RequiredPatientParameters')}}</b><br>
                    <p class="justified-text">{{DoseItem.requiredPatientParameters}}</p>

                    <div v-if="DoseItem.dosingMessages.length > 0">
                        <b>{{this.$t('FirstDataBank.DosingMessages')}}</b><br>
                         <div v-for="(i,key) in DoseItem.dosingMessages" :key="key"  class="mb-1">
                            <b>{{i.type}}</b><br>
                            <p class="justified-text">{{i.message}}</p>
                        </div>
                    </div>
            </b-col>
          </b-row>

      </BaseModal>

   </div>
</template>

<script>
import FirstDataBankService from '@/services/firstdatabank.service'
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import Permission from '@/common/Permission'
import Utils from "@/common/utils"

//import { EventBus } from '@/event-bus.js';
//import EnumService from '@/services/enum.service'


export default {
  name: 'DataBankSearch',
  props:{
     SearchCriteria:String,
     NDC:String,
     drugNameHeuristic:String,
     PatientAge:Number
  },
  mixins: [ShowMessage, DBFunctions, Permission],
  data(){
    return{
        DataBankList:[],
        SeveritiesList:[{code:1,name:"All"},{code:2,name:"Severe"},{code:3,name:"Less Severe"}],
        IdNotFound:false,
        packagedDrugID:"",
        LoadDetail:false,
        MainDose:{},
        VisibleDoseRecord:false,
        DoseItem:{},
        VisibleMainDose:false,
        ModelSeverities:{code:"",name:""},
        IsSeeMoreRecords:false,
        imageUrlList:[],
        ProfessionalMonographSectionList:[],
        ProfessionalMonographReferenceList:[],
        PatientEducationMonographsSectionList:[],
        VisibleProfessionalMonograph:false,
        FilterList:[{code:1,name:this.$t('FirstDataBank.DispensableDrug')},{code:2,name:this.$t('FirstDataBank.NDCID') },{code:3,name:this.$t('FirstDataBank.NDCDescription')}],
        ModelFilter:1,
        section: 'SeeAll',
        showDropdown:false,
        showSidebar: true,


        // ----------Begin See All -------------
        DataBankListAll:[],
        totalRowsDataBankListAll:0,
        currentPageDataBankListAll:1,
        perPageDataBankListAll:10,
        pageOptionsDataBankListAll: [5, 10, 15 ],
        ShowMessageIsEmptyDataBankListAll:false,
        fieldsDataBankListAll: [
            { key: 'name', sortable: true, label: this.$t('Shared.Description'), class: 'text-left' },
            { key: 'code', sortable: true, label: '', class: 'text-center hidden' },
            { key: 'federalLegendCodeDesc', sortable: true, label: this.$t('FirstDataBank.FederalLegendDescription') , class: 'text-left' },
            { key: 'doseFormDesc', sortable: true, label: this.$t('FirstDataBank.DoseFormDescription') , class: 'text-left' },

        ],
        // ----------Begin See All -------------

        ItemsIndication:[],
        totalRowsIndication:0,
        currentPageIndication:1,
        perPageIndication:10,
        pageOptionsIndication: [5, 10, 15 ],
        ShowMessageIsEmptyIndication:false,
        fieldsIndication: [
            { key: 'conditionDesc', sortable: true, label: this.$t('FirstDataBank.Condition'), class: 'text-left' },
            { key: 'conditionID', sortable: true, label: '', class: 'text-center hidden' },
            { key: 'indicationProxyPredictorCodeDesc', sortable: true, label: this.$t('FirstDataBank.LiklihoodPatientHas'), class: 'text-left' },
            { key: 'indicationLabeledCodeDesc', sortable: true, label: this.$t('FirstDataBank.Label'), class: 'text-left' },
        ],
        // ----------End Indication Item -------------

        // ----------Begin Side Effects -------------
        ItemsSideEffects:[],
        totalRowsSideEffects:0,
        currentPageSideEffects:1,
        perPageSideEffects:10,
        pageOptionsSideEffects: [5, 10, 15 ],
        ShowMessageIsEmptySideEffects:false,
        fieldsSideEffects: [
            { key: 'conditionDesc', sortable: true, label: this.$t('FirstDataBank.Condition'), class: 'text-left' },
            { key: 'conditionID', sortable: true, label: '', class: 'text-center hidden' },
            { key: 'frequencyOfOccurrenceCodeDesc', sortable: true, label: this.$t('FirstDataBank.Frequency'), class: 'text-left' },
            { key: 'severityDesc', sortable: true, label: this.$t('FirstDataBank.Severity'), class: 'text-left' },
        ],
        // ----------End Side Effects -------------


        // ----------Begin Drug Interactions -------------
        ItemsInteractions:[],
        totalRowsInteractions:0,
        currentPageInteractions:1,
        perPageInteractions:10,
        pageOptionsInteractions: [5, 10, 15 ],
        ShowMessageIsEmptyInteractions:false,
        fieldsInteractions: [
            { key: 'interactionDesc', sortable: true, label: this.$t('Shared.Description'), class: 'text-left' },
            { key: 'monographID', sortable: true, label: '', class: 'text-center hidden' },
            { key: 'severityDesc', sortable: true, label: this.$t('FirstDataBank.Severity'), class: 'text-left' },
            { key: 'fullClinicalEffect', sortable: true, label: this.$t('FirstDataBank.ClinicalEffect') , class: 'text-left' },
        ],
        // ----------End Drug Interactions -------------


        // ----------Begin Dose Records MinMax -------------
        ItemsDoseRecordsMinMax:[],
        totalRowsDoseRecordsMinMax:0,
        currentPageDoseRecordsMinMax:1,
        perPageDoseRecordsMinMax:10,
        pageOptionsDoseRecordsMinMax: [5, 10, 15 ],
        ShowMessageIsEmptyDoseRecordsMinMax:false,
        fieldsDoseRecordsMinMax: [
            { key: 'ageRange', sortable: true, label: this.$t('FirstDataBank.ageRange'), class: 'text-left' },
            { key: 'doseMin', sortable: true, label: this.$t('FirstDataBank.doseMin'), class: 'text-left' },
            { key: 'doseMax', sortable: true, label: this.$t('FirstDataBank.doseMax'), class: 'text-left' },
        ],
        // ----------End Dose Records MinMax -------------



        // ----------Begin LabelWarning -------------
        ItemsLabelWarning:[],
        totalRowsLabelWarning:0,
        currentPageLabelWarning:1,
        perPageLabelWarning:10,
        pageOptionsLabelWarning: [5, 10, 15 ],
        ShowMessageIsEmptyLabelWarning:false,
        fieldsLabelWarning: [
            { key: 'priority', sortable: true, label: this.$t('FirstDataBank.Priority') , class: 'text-left' },
            { key: 'labelWarningID', sortable: true, label: '', class: 'text-center hidden' },
            { key: 'labelWarningText', sortable: true, label: this.$t('FirstDataBank.LabelWarning'), class: 'text-left' },

        ],
        // ----------End LabelWarning -------------

        // ----------Begin Interoperability -------------
        ItemsInteroperability:[],
        totalRowsInteroperability:0,
        currentPageInteroperability:1,
        perPageInteroperability:10,
        pageOptionsInteroperability: [5, 10, 15 ],
        ShowMessageIsEmptyInteroperability:false,
        fieldsInteroperability: [
            { key: 'vocabularyTypeDesc', sortable: true, label: this.$t('FirstDataBank.VocabularyTypeDescription'), class: 'text-left' },
            { key: 'rxNormConceptID', sortable: true, label: '', class: 'text-center hidden' },
            { key: 'vocabularyTypeID', sortable: true, label: '', class: 'text-center hidden' },
            { key: 'rxNormConceptDesc', sortable: true, label: this.$t('Shared.Description'), class: 'text-left' },
            { key: 'vocabularyTypeOID', sortable: true, label: this.$t('FirstDataBank.VocabularyTypeOID'), class: 'text-left' },

        ],
        // ----------End Interoperability -------------


         // ----------Begin ClinicalQuantities -------------
        ItemsClinicalQuantities:[],
        totalRowsClinicalQuantities:0,
        currentPageClinicalQuantities:1,
        perPageClinicalQuantities:10,
        pageOptionsClinicalQuantities: [5, 10, 15 ],
        ShowMessageIsEmptyClinicalQuantities:false,
        fieldsClinicalQuantities: [
            { key: 'clinicalQuantityDesc', sortable: true, label: this.$t('Shared.Description'), class: 'text-left' },
            { key: 'subUnitQuantity', sortable: true, label: this.$t('FirstDataBank.SubUnitQuantity'), class: 'text-left' },
            { key: 'subUnitOfMeasureDesc', sortable: true, label: this.$t('FirstDataBank.SubUnitofMeasureDescription') , class: 'text-left' },
            { key: 'packageDesc', sortable: true, label: this.$t('FirstDataBank.PackageDescription'), class: 'text-left' },
            { key: 'eRxQuantity', sortable: true, label: this.$t('FirstDataBank.ERXQunatity'), class: 'text-left' },
            { key: 'eRxScriptPotencyUnitCode', sortable: true, label: this.$t('FirstDataBank.ERXScriptPotencyUnitCode'), class: 'text-left' },
            { key: 'eRxScriptUnitOfMeasureDesc', sortable: true, label: this.$t('FirstDataBank.ERXScriptUnitofMeasureDescription'), class: 'text-left' },


        ],
        // ----------End ClinicalQuantities -------------


         // ----------Begin Package -------------
        ItemsPackage:[],
        totalRowsPackageListAll:0,
        currentPagePackageListAll:1,
        perPagePackageListAll:10,
        pageOptionsPackageListAll: [5, 10, 15 ],
        ShowMessageIsEmptyPackageListAll:false,
        fieldsPackageListAll: [
            { key: 'packagedDrugDesc', sortable: true, label: this.$t('Shared.Description'), class: 'text-left' },
            { key: 'ndcFormatted', sortable: true, label: '', class: 'text-center hidden' },
            { key: 'packagedDrugID', sortable: true, label: '', class: 'text-center hidden' },
            { key: 'ndc', sortable: true, label: '', class: 'text-center hidden' },
            { key: 'labelerName', sortable: true, label: this.$t('FirstDataBank.Manufacturer'), class: 'text-left' },
            { key: 'hasImages', sortable: true, label: this.$t('FirstDataBank.HasImages'), class: 'text-left',formatter: value => {return value ? 'Y' : 'N'} },

        ],
        // ----------End Package -------------


        // ----------Begin Current Prices -------------
        ItemsCurrentPrices:[],
        totalRowsCurrentPrices:0,
        currentPageCurrentPrices:1,
        perPageCurrentPrices:10,
        pageOptionsCurrentPrices: [5, 10, 15 ],
        ShowMessageIsEmptyCurrentPrices:false,
        fieldsCurrentPrices: [
            { key: 'priceTypeCodeDesc', sortable: true, label: this.$t('Shared.Description'), class: 'text-left' },
            { key: 'priceTypeCode', sortable: true, label: this.$t('FirstDataBank.PriceType'), class: 'text-center' },
            { key: 'price', sortable: true, label: this.$t('FirstDataBank.PackagePrice'), class: 'text-center ' },
            { key: 'effectiveDate', sortable: true, label: this.$t('FirstDataBank.EffectiveDate'), class: 'text-center' },
        ],
        // ----------End Current Prices -------------



        // ----------Begin Dosing -------------
        ItemsDosing:[],
        totalRowsDosing:0,
        currentPageDosing:1,
        perPageDosing:10,
        pageOptionsDosing: [5, 10, 15 ],
        ShowMessageIsEmptyDosing:false,
        fieldsDosing: [
            { key: 'clinicalRoute', sortable: true, label: this.$t('Shared.Route') , class: 'text-left' },
            { key: 'frequency', sortable: true, label: this.$t('Shared.Frequency'), class: 'text-center' },
            { key: 'id', sortable: true, label: '', class: 'text-center hidden' },
            { key: 'doseThresholdRangesForm', sortable: true, label: this.$t('Shared.DoseThresholdRangesForm'), class: 'text-left' },
            { key: 'doseThresholdRangesMetric', sortable: true, label: this.$t('Shared.DoseThresholdRangesMetric'), class: 'text-left' },
            { key: 'maxSingleDosesForm', sortable: true, label: this.$t('Shared.MaxSingleDosesForm'), class: 'text-center' },
            { key: 'maxSingleDosesMetric', sortable: true, label: this.$t('Shared.MaxSingleDosesMetric'), class: 'text-center' },
            { key: 'notToExceedsForm', sortable: true, label: this.$t('Shared.NotToExceedSingleDosesForm'), class: 'text-center' },
            { key: 'notToExceedsMetric', sortable: true, label: this.$t('Shared.NotToExceedSingleDosesMetric'), class: 'text-center' },
        ],
        // ----------End Current Dosing -------------



        Detail:{
            dispensableDrugDesc:"",
            defaultETCDesc:"",
            activeIngredients:"",
            federalDEAClassCodeDesc:"",
            federalLegendCodeDesc:"",
            isMedicalDevice:"",
            isSingleIngredient:"",
            nameTypeCodeDesc:"",
            genericDrugNameCodeDesc:"",

        },
        //SearchCriteria:"",
    }
  },

  computed: {
    searchCriteriaLocal: {
            get() {
                return this.SearchCriteria;
            },
            set(value) {
                this.$emit('update:SearchCriteria', value);
            }
        },
    },

  methods:{
    print() {
        const content = document.getElementById('printArea');

        const win = window.open('', '_blank');

        win.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>Drug Information</title>

                <style>
                    body{
                        font-family: Arial;
                        margin:30px;
                        font-size:14px;
                    }

                    h1,h2,h3,h4{
                        margin-top:20px;
                    }
                </style>

            </head>
            <body>
                ${content.innerHTML}
            </body>
            </html>
        `);

        win.document.close();

        win.onload = () => {
            win.focus();
            win.print();
            win.close();
        };
    },

    DoseRecordOnCancel(){
        this.VisibleDoseRecord = false;
    },

    ChangeDropDownSeverities(){

    },


    async SeeMoreRecords(){
        await this.getDispensableSearchAll();
        this.section = "SeeAll";
        this.IsSeeMoreRecords = true;
    },
    ProfessionalMonographOnCancel(){
        this.VisibleProfessionalMonograph = false;
    },

    ProfessionalMonographOnOk(){
        this.VisibleProfessionalMonograph = false;
    },

   async handleViewEvent(item){
       await this.getProfessionalMonographsById(item.monographID);
        this.VisibleProfessionalMonograph = true;
    },

    handleViewPackageEvent(item){
        this.section = "details";
        this.IsSeeMoreRecords = false;
        this.packagedDrugID = item.packagedDrugID;
        this.Detail.dispensableDrugDesc = item.dispensableDrugDesc;
        this.Detail.defaultETCDesc = item.defaultETCDesc;
        this.Detail.activeIngredients = item.activeIngredients;
        this.Detail.federalDEAClassCodeDesc = item.federalDEAClassCodeDesc;
        this.Detail.federalLegendCodeDesc = item.federalLegendCodeDesc;
        this.Detail.isMedicalDevice = item.isMedicalDevice;
        this.Detail.isSingleIngredient = item.isSingleIngredient;
        this.Detail.nameTypeCodeDesc = item.nameTypeCodeDesc;
        this.Detail.genericDrugNameCodeDesc = item.genericDrugNameCodeDesc;
        this.LoadDetail = true;

        this.getImages(this.packagedDrugID);
        this.getIndicationDrugsById("PackagedDrugs",this.packagedDrugID);
        this.getSideEffectLinksDrugsById("PackagedDrugs",this.packagedDrugID);
        this.getInteractionDrugsById("PackagedDrugs",this.packagedDrugID);
        this.getPatientEducationMonographsById("PackagedDrugs",this.packagedDrugID);
        this.getDosingById("PackagedDrugs",this.packagedDrugID);
        this.getDoseRecordsMinMaxDispensableById("PackagedDrugs",this.packagedDrugID);
        this.getLabelWarningById("PackagedDrugs",this.packagedDrugID);
        this.getInteroperabilityById("PackagedDrugs",this.packagedDrugID);
        this.getCurrentPrices(this.packagedDrugID);
        this.getClinicalQuantitiesById("PackagedDrugs",this.packagedDrugID);


    },

    handleViewAllEvent(item){
        this.IsSeeMoreRecords = false;
        this.section = "details";
        this.ItemHandler(item);
    },

    DosingView(item){
       // this.DoseId = item.id;
        this.DoseItem = item;
        this.VisibleDoseRecord = true;
    },

    pageChangedPackageListAll(){

    },

    PerPageFunctionPackageListAll(){

    },

    pageChangedDosing(){

    },

    PerPageFunctionDosing(){

    },

    pageChangedCurrentPrices(){

    },

    PerPageFunctionCurrentPrices(){

    },

    pageChangedInteroperability(){

    },

    PerPageFunctionInteroperability(){

    },

    pageChangedDataBankListAll(){

    },

    PerPageFunctionDataBankListAll(){

    },

    pageChangedClinicalQuantities(){

    },

    PerPageFunctionClinicalQuantities(){

    },

    pageChangedLabelWarning(){

    },

    PerPageFunctionLabelWarning(){

    },

    pageChangedIndication(){

    },

    PerPageFunctionIndication(){

    },

    pageChangedInteractions(){

    },

    PerPageFunctionInteractions(){

    },

    pageChangedSideEffects(){

    },

    PerPageFunctionSideEffects(){

    },

    pageChangedDoseRecordsMinMax(){

    },

    PerPageFunctionDoseRecordsMinMax(){

    },


    ChangeDropDownFilter(item){
        this.ModelFilter = item.code;
        this.Reset();
    },

    Reset(){
        this.LoadDetail = false;
        this.showDropdown = false;
        this.searchCriteriaLocal = "";
        this.ItemsIndication = [];
        this.DataBankList = [];
        this.ItemsInteroperability = [];
        this.ProfessionalMonographSectionList = [];
        this.ProfessionalMonographReferenceList = [];
        this.PatientEducationMonographsSectionList = [];
        this.ItemsDoseRecordsMinMax = [];
        this.ItemsLabelWarning = [];
        this.totalRowsLabelWarning = 0;
        this.ItemsSideEffects = [];
        this.ItemsInteractions = [];
        this.ItemsClinicalQuantities = [];
        this.totalRowsDataBankListAll = 0;
        this.DataBankListAll = [];
        this.totalRowsClinicalQuantities = 0;
        this.totalRowsIndication = 0;
        this.totalRowsSideEffects = 0;
        this.totalRowsInteractions = 0;
        this.totalRowsInteroperability = 0;
        this.section = "details";
        this.ItemsCurrentPrices = [];
        this.totalRowsCurrentPrices = 0;
        this.ItemsPackage = [];
        this.totalRowsPackageListAll = 0;
        this.Detail = {
            dispensableDrugDesc:"",
            defaultETCDesc:"",
            activeIngredients:"",
            federalDEAClassCodeDesc:"",
            federalLegendCodeDesc:"",
            isMedicalDevice:"",
            isSingleIngredient:"",
            nameTypeCodeDesc:"",
            genericDrugNameCodeDesc:"",

        };
    },

    async getSearch(){
        if(this.SearchCriteria){
             let Type = this.ModelFilter === 1  ? "DispensableDrugs" :  "PackagedDrugs";
            if((this.ModelFilter === 1 || this.ModelFilter === 3)){
                await FirstDataBankService.getDrugs(this.SearchCriteria, 5, Type)
                .then((response) => {
                    var arr = response.data;
                    this.DataBankList = arr.items.map(item => (
                        {
                            code: this.ModelFilter === 1 ? item.dispensableDrugID : item.packagedDrugID,
                            name: item.dispensableDrugDesc
                        }
                    ));
                    this.showDropdown = true;
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
            }

            else{
               this.ItemHandler({code:this.SearchCriteria?.replace(/-/g, "") ?? ""});
            }


        }else{
            this.showDropdown = false;
            this.DataBankList = [];
        }
    },

   /* async getPackageSearch(Id){
            await FirstDataBankService.getPackagedDrugs("DispensableDrugs",Id,null)
                .then((response) => {
                    this.ItemsPackage = response.data.items;
                    this.totalRowsPackageListAll = this.ItemsPackage.length;
                    this.ShowMessageIsEmptyPackageListAll= this.ItemsPackage.length === 0 ? true : false;
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
    },*/



     async getDispensableSearchAll(){
        let Type = this.ModelFilter === 1  ? "DispensableDrugs" :  "PackagedDrugs";
        if(this.SearchCriteria){
            await FirstDataBankService.getDrugs(this.SearchCriteria,null,Type)
                .then((response) => {
                    var arr = response.data;
                    this.showDropdown = false;
                    // let mode = this.ModelFilter === 2 || this.ModelFilter === 3 ? "packagedDrug" : "dispensableDrug";
                    if(this.ModelFilter === 1){
                        this.DataBankListAll = arr.items.map(item => ({
                            code: item.dispensableDrugID,
                            name: item.dispensableDrugDesc,
                            federalLegendCodeDesc : item.federalLegendCodeDesc,
                            doseFormDesc : item.doseFormDesc
                        }));
                    this.totalRowsDataBankListAll = this.DataBankListAll.length;
                    this.ShowMessageIsEmptyDataBankListAll =  this.DataBankListAll.length === 0 ? true : false;
                    }else{
                         this.ItemsPackage = arr.items.map(item => ({
                            packagedDrugID: item.packagedDrugID,
                            packagedDrugDesc: item.packagedDrugDesc,
                            labelerName:item.labelerName,
                            ndcFormatted:item.ndcFormatted,
                            defaultETCDesc:item.defaultETCDesc,
                            isMedicalDevice : item.isMedicalDevice ? "YES" : "NO",
                            isSingleIngredient : item.isSingleIngredient ? "YES" :"NO",
                            dispensableDrugDesc:item.dispensableDrugDesc,
                            ndc:item.ndc,
                            genericDrugNameCodeDesc:item.genericDrugNameCodeDesc,
                            nameTypeCodeDesc:item.nameTypeCodeDesc,
                            hasImages:item.hasImages,
                            federalLegendCodeDesc : item.federalLegendCodeDesc,
                            doseFormDesc : item.doseFormDesc
                    }));
                    this.totalRowsPackageListAll = this.ItemsPackage.length;
                    this.ShowMessageIsEmptyPackageListAll= this.ItemsPackage.length === 0 ? true : false;
                    }


                    /*
        this.Detail.activeIngredients = item.activeIngredients;
                            */

                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        }else{
            this.showDropdown = false;
            this.DataBankListAll = [];
        }
    },

    async ItemHandler(item){
        this.section = "details";
      if(this.ModelFilter === 1){
        this.getSearchById("DispensableDrugs",item.code);
        this.getIndicationDrugsById("DispensableDrugs",item.code);
        this.getSideEffectLinksDrugsById("DispensableDrugs",item.code);
        this.getInteractionDrugsById("DispensableDrugs",item.code);
        this.getPatientEducationMonographsById("DispensableDrugs",item.code);
        this.getDosingById("DispensableDrugs",item.code);
        this.getDoseRecordsMinMaxDispensableById("DispensableDrugs",item.code);
        this.getLabelWarningById("DispensableDrugs",item.code);
        this.getInteroperabilityById("DispensableDrugs",item.code);
        this.getClinicalQuantitiesById("DispensableDrugs",item.code);
      }else if(this.ModelFilter === 2){
            await this.getSearchById("PackagedDrugs",item.code);
            if(!this.IdNotFound){
                this.getImages(item.code);
                this.getIndicationDrugsById("PackagedDrugs",item.code);
                this.getSideEffectLinksDrugsById("PackagedDrugs",item.code);
                this.getInteractionDrugsById("PackagedDrugs",item.code);
                this.getDoseRecordsMinMaxDispensableById("PackagedDrugs",item.code);
                this.getDosingById("PackagedDrugs",item.code);
                this.getPatientEducationMonographsById("PackagedDrugs",item.code);
                this.getLabelWarningById("PackagedDrugs",item.code);
                this.getInteroperabilityById("PackagedDrugs",item.code);
                this.getCurrentPrices(item.code);
                this.getClinicalQuantitiesById("PackagedDrugs",item.code);
            }else{
                this.showMessage(this.$tc('Msg.Error'),this.$tc('FirstDataBank.NotFound'),"error");
            }

      }
      else{
        await this.getSearchById("PackagedDrugs",item.code);
            if(!this.IdNotFound){
                this.getImages(item.code);
                this.getIndicationDrugsById("PackagedDrugs",item.code);
                this.getSideEffectLinksDrugsById("PackagedDrugs",item.code);
                this.getInteractionDrugsById("PackagedDrugs",item.code);
                this.getDoseRecordsMinMaxDispensableById("PackagedDrugs",item.code);
                this.getDosingById("PackagedDrugs",item.code);
                this.getPatientEducationMonographsById("PackagedDrugs",item.code);
                this.getLabelWarningById("PackagedDrugs",item.code);
                this.getInteroperabilityById("PackagedDrugs",item.code);
                this.getCurrentPrices(item.code);
                this.getClinicalQuantitiesById("PackagedDrugs",item.code);
            }else{
                this.showMessage(this.$tc('Msg.Error'),this.$tc('FirstDataBank.NotFound'),"error");
            }
      }
    },

     async getSearchById(Type,Id){
        await FirstDataBankService.getDrugsById(Type,Id)
            .then((response) => {
                if(response.data){
                    this.IdNotFound = false;
                    let type = this.ModelFilter === 2 || this.ModelFilter === 3 ? "packagedDrug" : "dispensableDrug";
                    this.Detail.dispensableDrugDesc = response.data[type].dispensableDrugDesc;
                    this.Detail.defaultETCDesc = response.data[type].defaultETCDesc;
                    this.Detail.activeIngredients = response.data[type]?.ingredients?.length > 0 ? response.data[type].ingredients.map(item => item.ingredientDesc).join(", ") : ""; // response.data.dispensableDrug.activeIngredients;
                    this.Detail.federalDEAClassCodeDesc = response.data[type].federalDEAClassCodeDesc;
                    this.Detail.federalLegendCodeDesc = response.data[type].federalLegendCodeDesc;
                    this.Detail.isMedicalDevice = response.data[type].isMedicalDevice ? "Yes" : "No";
                    this.Detail.isSingleIngredient = response.data[type].isSingleIngredient ? "Yes" : "No";
                    this.Detail.nameTypeCodeDesc = response.data[type].nameTypeCodeDesc;
                    this.Detail.genericDrugNameCodeDesc = response.data[type].genericDrugNameCodeDesc;
                    this.LoadDetail = true;
                }
            })
            .catch(error => {
                const { status } = error.response;
                if(status === 404){
                    this.IdNotFound = true;
                }else{
                    this.showResponseErrorMessage(error);
                }

            });
    },

    getIndicationDrugsById(Type,Id){
         FirstDataBankService.getIndicationsById(Type,Id)
            .then((response) => {
                this.ItemsIndication = response.data.items;
                this.totalRowsIndication = this.ItemsIndication.length;
                this.ShowMessageIsEmptyIndication = this.ItemsIndication.length === 0 ? true : false;

            })
            .catch(error => {
                this.showResponseErrorMessage(error);
            });
    },

    getSideEffectLinksDrugsById(Type,Id){
         FirstDataBankService.getSideEffectLinksById(Type,Id)
            .then((response) => {
                this.ItemsSideEffects = response.data.items;
                this.totalRowsSideEffects = this.ItemsSideEffects.length;
                this.ShowMessageIsEmptySideEffects = this.ItemsSideEffects.length === 0 ? true : false;

            })
            .catch(error => {
                this.showResponseErrorMessage(error);
            });
    },

    getInteractionDrugsById(Type,Id){
         FirstDataBankService.getInteractionsById(Type,Id)
            .then((response) => {
                var arr = response.data.items;
                arr.forEach(element => {
                    element.fullClinicalEffect = [element.clinicalEffect1Desc, element.clinicalEffect2Desc].filter(Boolean).join(', ');
                });
                this.ItemsInteractions = arr;
                this.totalRowsInteractions = this.ItemsInteractions.length;

                this.ShowMessageIsEmptyInteractions = this.ItemsInteractions.length === 0 ? true : false;
            })
            .catch(error => {
                this.showResponseErrorMessage(error);
            });
    },

    async getProfessionalMonographsById(Id){
        await FirstDataBankService.getProfessionalMonographsById(Id)
            .then((response) => {
               this.ProfessionalMonographSectionList = response.data?.monograph?.sections;
               this.ProfessionalMonographReferenceList = response.data?.monograph?.referenceSections;
            })
            .catch(error => {
                this.showResponseErrorMessage(error);
            });
    },

    async getPatientEducationMonographsById(Type,Id){
        await FirstDataBankService.getPatientEducationMonographsById(Type,Id)
            .then((response) => {
               this.PatientEducationMonographsSectionList = response.data?.monograph?.sections;
            })
            .catch(error => {
                this.showResponseErrorMessage(error);
            });
    },

    formatDays(daysString) {
        const days = Number(daysString);
        if (days >= 365) {
            const years = Math.round(days / 365);
            return `${years} `+this.$t('Shared.year');
        }

        if (days >= 30) {
            const months =  Math.round(days / 30);
            return `${months} `+this.$t('Shared.month');
        }

        return `${days} `+this.$t('Shared.day');
    },

    formatOnlyDays(daysString) {
        const days = Number(daysString);
        if (days >= 365) {
            return Math.round(days / 365);
        }

        if (days >= 30) {
            return  Math.round(days / 30);
        }

        return days;
    },

    isInRange(number, min, max) {
        return number >= min && number <= max;
    },

    getDoseRecordsMinMaxDispensableById(Type,Id){
         FirstDataBankService.getDosageRecordsById(Type,Id,"MinMax")
            .then((response) => {
               let arr = response.data.items;
               arr.forEach(element => {
                    if(!element.isExcluded){
                        let minString = this.formatDays(element.patientAgeInDaysLow);
                        let maxString = this.formatDays(element.patientAgeInDaysHigh);
                        element.ageRange = minString + " - "+maxString;
                        element.doseMin = element.doseThresholdRanges.metricLowValue + " "+element.doseThresholdRanges.metricLowUnit;
                        element.doseMax = element.doseThresholdRanges.metricMaxValue + " "+element.doseThresholdRanges.metricMaxUnit;


                        let min = this.formatOnlyDays(element.patientAgeInDaysLow);
                        let max = this.formatOnlyDays(element.patientAgeInDaysHigh);

                        if(this.PatientAge && this.isInRange(this.PatientAge,min,max)){
                            this.VisibleMainDose = true;
                            this.MainDose.ageRange = element.ageRange;
                            this.MainDose.doseMin = element.doseMin;
                            this.MainDose.doseMax = element.doseMax;
                        }


                    }
               });

               this.ItemsDoseRecordsMinMax = arr.filter(item => item.isExcluded === false);



                this.totalRowsDoseRecordsMinMax = this.ItemsDoseRecordsMinMax.length;
                this.ShowMessageIsEmptyDoseRecordsMinMax = this.ItemsDoseRecordsMinMax.length === 0 ? true : false;

            })
            .catch(error => {
                this.showResponseErrorMessage(error);
            });
    },

    getLabelWarningById(Type,Id){
         FirstDataBankService.getLabelWarningDrugLinksById(Type,Id)
            .then((response) => {
                this.ItemsLabelWarning = response.data.items;
                this.totalRowsLabelWarning = this.ItemsLabelWarning.length;
                this.ShowMessageIsEmptyLabelWarning = this.ItemsLabelWarning.length === 0 ? true : false;
            })
            .catch(error => {
                this.showResponseErrorMessage(error);
            });
    },

    getInteroperabilityById(Type,Id){
         FirstDataBankService.getInteroperabilityById(Type,Id)
            .then((response) => {
                this.ItemsInteroperability = response.data.items;
                this.totalRowsInteroperability = this.ItemsInteroperability.length;
                this.ShowMessageIsEmptyInteroperability = this.ItemsInteroperability.length === 0 ? true : false;
            })
            .catch(error => {
                this.showResponseErrorMessage(error);
            });
    },

    getClinicalQuantitiesById(Type,Id){
         FirstDataBankService.getClinicalQuantitiesById(Type,Id)
            .then((response) => {
                this.ItemsClinicalQuantities = response.data.items !== null ?  response.data.items : [];
                this.totalRowsClinicalQuantities = this.ItemsClinicalQuantities.length;
                this.ShowMessageIsEmptyClinicalQuantities = this.ItemsClinicalQuantities.length === 0 ? true : false;
            })
            .catch(error => {
                this.showResponseErrorMessage(error);
            });
    },

     getDosingById(Type,Id){
         FirstDataBankService.getDosageRecordsById(Type,Id)
            .then((response) => {

                let arr = response.data.items !== null ?  response.data.items : [];

                arr.forEach( (element,index) => {
                    element.id = index;
                    element.frequency = element.frequencyRanges.form;
                    element.doseThresholdRangesForm = element.doseThresholdRanges.form;
                    element.doseThresholdRangesMetric = element.doseThresholdRanges.metric;
                    element.maxSingleDosesForm = element.singleDoses.maxSingleDoses.form;
                    element.maxSingleDosesMetric = element.singleDoses.maxSingleDoses.metric;
                    element.notToExceedsForm = element.singleDoses.notToExceeds.form;
                    element.notToExceedsMetric = element.singleDoses.notToExceeds.metric;
                });


                this.ItemsDosing = arr;
                this.totalRowsDosing = this.ItemsDosing.length;
                this.ShowMessageIsEmptyDosing = this.ItemsDosing.length === 0 ? true : false;
            })
            .catch(error => {
                this.showResponseErrorMessage(error);
            });
    },

    getImages(Id){
         FirstDataBankService.getPackagedDrugsImage(Id)
            .then((response) => {
                this.imageUrlList = response.data.items;
            })
            .catch(error => {
                this.showResponseErrorMessage(error);
            });
    },

    getCurrentPrices(Id){
         FirstDataBankService.getPackageDrugCurrentPrice(Id)
            .then((response) => {
                this.ItemsCurrentPrices = response.data.items;
                this.ItemsCurrentPrices.forEach(element => {
                    element.effectiveDate = element.effectiveDate ? Utils.formatterDateToString(element.effectiveDate) : null;
                });
                this.totalRowsCurrentPrices = this.ItemsCurrentPrices.length;
                this.ShowMessageIsEmptyCurrentPrices = this.ItemsCurrentPrices.length === 0 ? true : false;
            })
            .catch(error => {
                this.showResponseErrorMessage(error);
            });
    },

    SearchHandler(){
        this.getSearch();
    },

  },

 async mounted(){

    if(this.NDC !== null){
        this.ModelFilter = 2;
        this.searchCriteriaLocal = this.NDC;
        this.ItemHandler({code:this.NDC});
    }else{
         this.searchCriteriaLocal = this.drugNameHeuristic;
        if(this.SearchCriteria !== null && this.SearchCriteria !== ""){
            await this.getSearch();
            this.showDropdown = this.DataBankList.length > 0 ? true : false;
        }
    }


  }

};
</script>
<style>
@media print {

  /* Oculta todo */
  body * {
    visibility: hidden;
  }

  /* Muestra solamente printArea */
  #printArea,
  #printArea * {
    visibility: visible;
  }

  /* Lo posiciona ocupando toda la hoja */
  #printArea {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background: white;
    padding: 20px;
  }

  /* Cualquier elemento con esta clase nunca se imprime */
  .no-print {
    display: none !important;
  }

}
</style>

<style scoped>



.image-container {
  display: flex;
  flex-wrap: wrap; /* opcional, para que bajen de línea si no caben */
  gap: 15px; /* espacio entre imágenes */
}

.image-gallery {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
}

.image-card {
    background: #fff;
    border: 2px solid #d9eef5;
    border-radius: 8px;
    padding: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,.08);
    transition: all .2s ease;
}

.image-card:hover {
    border-color: #00A7D8;
    box-shadow: 0 4px 15px rgba(0,167,216,.2);
    transform: translateY(-2px);
}

/**/

.image-card {
    width: 300px;
    background: #f8fcfd;
    border: 1px solid #b8dce7;
    border-radius: 8px;
    padding: 10px;
}

.image-card img {
    border-radius: 4px;
}

.image-card:hover {
    border-color: #00A7D8;
}

/**/
.image-label {
    text-align: center;
    margin-top: 8px;
    color: #007ea3;
    font-size: 13px;
    font-weight: 600;
}

.empty-images {
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #8a8a8a;
  border: 1px dashed #d5d5d5;
  border-radius: 4px;
  background: #fafafa;
}

.empty-icon {
  font-size: 60px;
  margin-bottom: 15px;
  color: #bdbdbd;
}

.empty-images h3 {
  margin: 0 0 8px;
  color: #666;
  font-weight: 500;
}

.empty-images p {
  margin: 0;
  font-size: 14px;
}


.layout {
  display: flex;
  min-height: 400px;
  position: relative;

  /* 🔥 importante */
  align-items: stretch;
}

/* =========================
   SIDEBAR
   ========================= */

.sidebar {
  flex: 0 0 240px;
  flex-shrink: 0;

  background: linear-gradient(
    to bottom,
    #f4fbfe 0%,
    #e6f6fc 100%
  );

  border: 1px solid #cce8f2;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 168, 214, 0.08);

  overflow: hidden;
}

/* 🔥 FIX DEFINITIVO */
.sidebar.collapsed {
  display: none;
}

/* =========================
   LISTA
   ========================= */

.sidebar ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.sidebar li {
  padding: 12px 16px;
  color: #0b5f7d;
  cursor: pointer;
  border-left: 4px solid transparent;
  transition: all .2s ease;
}

.sidebar li:hover {
  background: rgba(0, 168, 214, 0.08);
  color: #00a8d6;
  transform: translateX(3px);
}

.sidebar li.active {
  background: linear-gradient(
    to right,
    rgba(0, 168, 214, 0.18),
    rgba(0, 168, 214, 0.05)
  );
  color: #007fa3;
  border-left: 4px solid #00a8d6;
  font-weight: 700;
}

.sidebar li:first-child {
  border-top-left-radius: 8px;
}

.sidebar li:last-child {
  border-bottom-left-radius: 8px;
}

.position-relative {
    position: relative;
}

.print-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 22px;
    z-index: 1000;
}

.content {
  flex: 1;
  min-width: 0;
  padding: 5px 5px;
}

/* =========================
   BOTÓN TOGGLE
   ========================= */

.sidebar-toggle {
  width: 36px;
  min-width: 36px;
  max-width: 36px;

  flex: 0 0 36px;

  margin-left: -1px;

  border: 1px solid #cce8f2;
  border-left: none;

  background: linear-gradient(
    to bottom,
    #f4fbfe 0%,
    #e6f6fc 100%
  );

  color: #007fa3;
  cursor: pointer;
  padding: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  align-self: stretch;

  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;

  transition: background .2s ease;
}

.sidebar-toggle:hover {
  background: rgba(0, 168, 214, 0.08);
}

.sidebar-toggle:focus {
  outline: none;
}

.separate{
    width: 10px;
}

/* Cuando el sidebar está oculto */
.sidebar.collapsed + .sidebar-toggle {
  margin-left: 0;
  border-left: 1px solid #cce8f2;

  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
}

.justified-text {
    text-align: justify;
}
/*
.justified-text::after {
    content: "";
    display: inline-block;
    width: 100%;
}*/

.border-right-column {
    border-right: 1px solid #dcdcdc;
    padding-right: 20px;
}

.border-right-column + .col-md-6 {
    padding-left: 20px;
}

@media (max-width: 768px) {
  .layout {
    flex-direction: column;
  }

  .sidebar {
    width: 100%;
    flex: none;
  }

  .separate {
    display: none;
  }
}
</style>
